import { ArquivoBinario } from "../model/arquivo-binario.model";
import { Segmento, SegmentoTela } from "../model/segmento.model";
import { VisaoSegmento } from "../model/visao-segmento.model";
import { Base64 } from "./base64.util";
import { QuillHtmlUtil } from "./quill-html.util";

export class SegmentoTelaUtil {

    public static criarDoSegmento(segmento: Segmento): SegmentoTela {
        const segmentoTela = new SegmentoTela();
        segmentoTela.idSegmento = segmento.idSegmento;
        segmentoTela.versaoSegmento = segmento.versaoSegmento;
        segmentoTela.idTipoSegmento = segmento.idTipoSegmento;
        segmentoTela.idAssunto = segmento.idAssunto;
        segmentoTela.textoIntegra = segmento.textoIntegra.replaceAll('\n', '');
        segmentoTela.original = segmento.original;
        segmentoTela.compilado = segmento.compilado;
        segmentoTela.estiloSegmento = segmento.estiloSegmento;

        if (segmento.idTipoSegmento == 16) {
            segmentoTela.arquivoBinario = segmento.arquivoBinario;
            if ([4,5].indexOf(segmento.arquivoBinario?.idTipoArquivo) >= 0) {
                segmentoTela.innerHTML = Base64.decode(segmento.arquivoBinario.arquivoBinario);
            }
        }
        return segmentoTela;
    }

    public static criarDeVisaoSegmento(visaoSegmento: VisaoSegmento): SegmentoTela {
        const segmentoTela = new SegmentoTela();
        segmentoTela.idSegmento = visaoSegmento.idSegmento;
        segmentoTela.versaoSegmento = visaoSegmento.versaoSegmento;
        segmentoTela.idTipoSegmento = visaoSegmento.idTipoSegmento;
        segmentoTela.idAssunto = visaoSegmento.idAssunto;
        segmentoTela.textoIntegra = visaoSegmento.textoIntegra.replaceAll('\n', '');
        segmentoTela.original = visaoSegmento.original;
        segmentoTela.compilado = visaoSegmento.compilado;
        segmentoTela.estiloSegmento = visaoSegmento.estiloSegmento;

        if (visaoSegmento.idTipoSegmento == 16) {
            segmentoTela.arquivoBinario = visaoSegmento.arquivoBinario;
            if ([4,5].indexOf(visaoSegmento.arquivoBinario?.idTipoArquivo) >= 0) {
                segmentoTela.innerHTML = Base64.decode(visaoSegmento.arquivoBinario.arquivoBinario);
            }
        }
        return segmentoTela;
    }

    public static obterSegmentoParaSalvar(segmentoTela: SegmentoTela): Segmento {
        const segmento = new Segmento();
        if (segmentoTela.idSegmento) {
            segmento.idSegmento = segmentoTela.idSegmento;
        }
        segmento.versaoSegmento = segmentoTela.versaoSegmento;
        segmento.idTipoSegmento = segmentoTela.idTipoSegmento ? segmentoTela.idTipoSegmento : 999;
        segmento.idAssunto = segmentoTela.idAssunto ? segmentoTela.idAssunto : 1;

        if (segmentoTela.ordemSegmentoAto) {
            segmento.ordemSegmentoAto = segmentoTela.ordemSegmentoAto;
        }

        if (segmentoTela.textoIntegra) {
            const s = segmentoTela.textoIntegra.replaceAll('\n', '');
            segmento.textoIntegra = QuillHtmlUtil.ajustarHTML(s);
        } else {
            segmento.textoIntegra = '';
        }
    
        if (segmentoTela.arquivoBinario) {
            const id = segmentoTela.arquivoBinario.idArquivoBinario;
            segmento.arquivoBinario = new ArquivoBinario();
            segmento.arquivoBinario.idArquivoBinario = id;
        }
    
        segmento.estiloSegmento = segmentoTela.estiloSegmento;

        return segmento;
    }
}
